<!-- <div class="container-fluid">
  <app-pagetitle title="Program" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-between">
            <a class="btn btn-success mb-2" (click)="openModal(content, '', 'Add')">
              <i class="mdi mdi-plus mr-2"></i> Add Program
            </a>
            <div>
              <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
            </div>
          </div>

          <div class="table-responsive mt-3" *ngIf="programData.length != 0">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%">
              <thead class="thead-dark">
                <tr>
                  <th>Part Id</th>
                  <th>Program Name</th>
                  <th>Part Name</th>
                  <th>Operation</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of programData | filter: searchTerm | slice: pageSize | slice: 0: itemsPerPage; let i = index">
                  <td>{{ item.programId }}</td>
                  <td>{{ item.programName }}</td>
                  <td>{{ item.partName }}</td>
                  <td>
                    <i class="mdi mdi-eye" title="View" style="cursor: pointer;"
                      (click)="openModalOperation(Operation, item)"></i>
                  </td>
                  <td>
                    <a (click)="openModal(content, item, 'Edit')" class="mr-3 text-primary" title="Edit" style="cursor: pointer">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a class="text-danger" title="Delete" style="cursor: pointer" (click)="openModalDelete(deletetemp, item)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6" *ngIf="programData?.length > 3">
              <ngb-pagination class="pagination-rounded" [collectionSize]="programData?.length" #numPages
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true"
                [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
              </ngb-pagination>
            </div>
          </div>

          <div class="card" *ngIf="programData.length == 0">
            <span *ngIf="errmsg == ''"><strong>No Program Found. Please Add Program</strong></span>
            <span *ngIf="errmsg != ''"><strong>{{ errmsg }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }} Program</h5>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="validationform" autocomplete="off">

        <div class="row">
          <div class="form-group col-md-6">
            <label for="programId" class="required">Part Id</label>
            <input type="text" maxlength="32" class="form-control" id="programId"
              placeholder="Enter Part Id" formControlName="programId"
              [ngClass]="{ 'is-invalid': submitted && form.programId.errors }" />
            <div *ngIf="submitted && form.programId.errors" class="invalid-feedback">
              <span *ngIf="form.programId.errors.required">Part Id is mandatory.</span>
            </div>
          </div>

          <div class="form-group col-md-6">
            <label for="programName">Program Name</label>
            <input type="text" maxlength="32" class="form-control" id="programName"
              placeholder="Enter Program Name" formControlName="programName"
              [ngClass]="{ 'is-invalid': submitted && form.programName.errors }" />
            <div *ngIf="submitted && form.programName.errors" class="invalid-feedback">
              <span *ngIf="form.programName.errors.required">Program Name is mandatory.</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="partName" class="required">Part/Model Name</label>
            <input type="text" maxlength="64" class="form-control" id="partName"
              placeholder="Enter Part Name" formControlName="partName" 
              [ngClass]="{ 'is-invalid': submitted && form.partName.errors }" />
            <div *ngIf="submitted && form.partName.errors" class="invalid-feedback">
              <span *ngIf="form.partName.errors.required">Part Name is mandatory.</span>
              <span *ngIf="form.partName.errors.pattern">Only letters, numbers, and underscores are allowed.</span>
            </div>
          </div>

          <div class="form-group col-md-6">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="partsPerCycleRadio"
                value="partsPerCycle" formControlName="countingType" />
              <label class="form-check-label" for="partsPerCycleRadio">Parts per Cycle</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="unitsPerPartRadio"
                value="unitsPerPart" formControlName="countingType" />
              <label class="form-check-label" for="unitsPerPartRadio">Units per Part</label>
            </div>

            <input type="number" class="form-control mt-1" id="partsPerCycle"
              [placeholder]="validationform.get('countingType').value == 'partsPerCycle' ? 'Enter Part Per Cycle' : 'Enter Units Per Part'"
              formControlName="partsPerCycle"
              [ngClass]="{ 'is-invalid': submitted && form.partsPerCycle.errors }" />
            <div *ngIf="submitted && form.partsPerCycle.errors" class="text-danger" style="font-size: 12px; margin-top: 4px;">
              <span *ngIf="form.partsPerCycle.errors?.required">Part per cycle is mandatory.</span>
              <span *ngIf="form.partsPerCycle.errors?.negativeValue">Value cannot be negative.</span>
              <span *ngIf="form.partsPerCycle.errors?.decimalNotAllowed">Decimal values are not allowed.</span>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="form-group col-md-6 d-flex">
            <label for="type">To configure CycleTime</label>&nbsp;
            <input class="form-control" style="width: 15px; margin-top: -10px" type="checkbox"
              [(ngModel)]="isChecked" [ngModelOptions]="{ standalone: true }"
              (change)="onCheckboxChange($event)" id="type" [disabled]="action == 'Edit'" />
          </div>
          <div class="form-group col-md-6 d-flex">
            <label for="operatorCost">To include OperatorCost</label>&nbsp;
            <input class="form-control" style="width: 15px; margin-top: -10px" type="checkbox"
              id="operatorCost" formControlName="operatorCost" />
          </div>
        </div>

        <div class="row" *ngIf="!isChecked">
          <div class="form-group col-md-6" *ngIf="validationform?.get('fixedCost')">
            <label for="fixedCost">Fixed Cost</label>
            <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select FixedCost'"
              [settings]="settings" [data]="fixedCostData" formControlName="fixedCost"
              style="color: #000"></ng-multiselect-dropdown>
          </div>
          <div class="form-group col-md-6" *ngIf="validationform?.get('variableCost')">
            <label for="variableCost">Variable Cost</label>
            <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select VariableCost'"
              [settings]="settings" [data]="variableCostData" formControlName="variableCost"
              style="color: #000"></ng-multiselect-dropdown>
          </div>
        </div>

        <div class="row" *ngIf="isChecked && !issecChecked">
          <div class="form-group col-md-6" *ngIf="validationform?.get('fixedCosts')">
            <label for="fixedCosts">Fixed Cost</label>
            <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select FixedCost'"
              [settings]="settings" [data]="fixedCostData" formControlName="fixedCosts"
              style="color: #000"></ng-multiselect-dropdown>
          </div>
          <div class="form-group col-md-6" *ngIf="validationform?.get('variableCosts')">
            <label for="variableCosts">Variable Cost</label>
            <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select VariableCost'"
              [settings]="settings" [data]="variableCostData" formControlName="variableCosts"
              style="color: #000"></ng-multiselect-dropdown>
          </div>
        </div>

        <div class="row" *ngIf="isChecked && issecChecked">
          <div class="form-group col-md-6" *ngIf="validationform?.get('fixedCostss')">
            <label for="fixedCostss">Fixed Cost</label>
            <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select FixedCost'"
              [settings]="settings" [data]="fixedCostData" formControlName="fixedCostss"
              style="color: #000"></ng-multiselect-dropdown>
          </div>
          <div class="form-group col-md-6" *ngIf="validationform?.get('variableCostss')">
            <label for="variableCostss">Variable Cost</label>
            <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select VariableCost'"
              [settings]="settings" [data]="variableCostData" formControlName="variableCostss"
              style="color: #000"></ng-multiselect-dropdown>
          </div>
        </div>
         <hr>
        <div class="row" *ngIf="isChecked">
          <div class="form-group col-md-6 d-flex">
            <label for="sectype">To configure Sequential CycleTime</label>&nbsp;
            <input class="form-control" style="width: 15px; margin-top: -10px" type="checkbox"
              [(ngModel)]="issecChecked" [ngModelOptions]="{ standalone: true }"
              (change)="onsecCheckboxChange($event)" id="sectype" [disabled]="action == 'Edit'" />
          </div>
        </div>


        <div class="row">

          <div class="col-md-12" formArrayName="operationData" *ngIf="isChecked && !issecChecked">
            <div class="row mb-3"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">
              <div class="col-12">
                <div class="row align-items-start">
                 <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                      <label for="processName">Process Name</label>
                        <select
                            id="processName"
                            class="form-control"
                            formControlName="processName"
                          >
                            <option value="" selected disabled>Select Process</option>
                            <option *ngFor="let process of processData" [value]="process.processName">
                              {{ process.processName }}
                            </option>
                          </select>
                
                 </div>
                  <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                    <label class="required">Operation Number</label>
                    <input type="number" class="form-control" placeholder="Number"
                      formControlName="operationName"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Operation Number must be unique.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                    <label class="required">Running Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Sec"
                      formControlName="runningTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.runningTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.runningTime').errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                    <label class="required">Loading Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Sec"
                      formControlName="loadingTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.loadingTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.loadingTime').errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                    <label class="required">Unloading Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Sec"
                      formControlName="unloadingTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.unloadingTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.unloadingTime').errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                 
                  <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                    <label class="required">Setup Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Sec"
                      formControlName="standardSetupTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

               
                  <div class="col-12 col-sm-6 col-md-2 mb-2 d-flex align-items-center"
                    *ngIf="validationform.get('operationData')['controls'].length > 1">
                    <span style="cursor: pointer;" title="Remove" (click)="removeOperation(i)">
                      <i class="fas fa-minus-circle text-danger"></i>
                    </span>
                  </div>

                </div>
              </div>
            </div>
          </div>

    
          <div class="col-md-12" formArrayName="operationData" *ngIf="isChecked && issecChecked">
            <div class="card mb-3"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">

              <div class="card-header d-flex justify-content-between align-items-start flex-wrap gap-2">

            
                 <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                <label for="processName">Process Name</label>
                  <select
                      id="processName"
                      class="form-control"
                      formControlName="processName"
                    >
                      <option value="" selected disabled>Select Process</option>
                      <option *ngFor="let process of processData" [value]="process.processName">
                        {{ process.processName }}
                      </option>
                    </select>
                   
                 </div>
                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Operation Number</label>
                  <input type="number" class="form-control" formControlName="operationName"
                    placeholder="Operation Number"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors"
                    class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Operation Number must be unique.</span>
                  </div>
                </div>

               
                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Loading Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec"
                    formControlName="loadingTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.loadingTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.loadingTime').errors"
                    class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

              
                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Unloading Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec"
                    formControlName="unloadingTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.unloadingTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.unloadingTime').errors"
                    class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

            
                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Setup Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec"
                    formControlName="standardSetupTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors"
                    class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

            
                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Total Runtime (sec)</label>
                  <input type="number" class="form-control" formControlName="runningTime"
                    placeholder="Total Runtime" readonly />
                </div>

             
                <div class="col-12 col-sm-6 col-md-2 mb-2 d-flex align-items-center"
                  *ngIf="validationform.get('operationData')['controls'].length > 1">
                  <span style="cursor: pointer;" title="Remove" (click)="removeOperation(i)">
                    <i class="fas fa-minus-circle text-danger"></i>
                  </span>
                </div>

              </div>

         
              <div class="card-body" formArrayName="sequenceData">
                <div class="row">
                  <div class="form-group col-md-6">
                    <h4 class="card-title">
                      Add Sequence
                      <span style="position: absolute; margin-left: 2%">
                        <i class="fas fa-plus-circle" (click)="addSequenceOperation(i)"
                          style="color: rgb(72, 255, 0); cursor: pointer; margin-left: 10px;"
                          title="Add Sequence"></i>
                      </span>
                    </h4>
                  </div>
                </div>

                <div class="row mb-3"
                  *ngFor="let seq of operation.get('sequenceData')['controls']; let j = index"
                  [formGroupName]="j">

              
                  <div class="form-group col-12 col-sm-6 col-md-3 mb-2">
                    <label class="required">Sequence Number</label>
                    <input type="text" class="form-control" formControlName="seqNumber"
                      placeholder="Sequence"
                      [ngClass]="{ 'is-invalid': submitted && operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors }" />
                    <div *ngIf="submitted && operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors?.required">Required.</span>
                    </div>
                  </div>

       
                  <div class="form-group col-12 col-sm-6 col-md-3 mb-2">
                    <label class="required">Running Time (sec)</label>
                    <input type="number" class="form-control" formControlName="runningTime"
                      placeholder="Sec" (input)="calculateTotalRuntime(i)"
                      [ngClass]="{ 'is-invalid': submitted && operation.get('sequenceData')['controls'][j].get('runningTime')?.errors }" />
                    <div *ngIf="submitted && operation.get('sequenceData')['controls'][j].get('runningTime')?.errors"
                      class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.required">Required.</span>
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

   
                  <div class="col-12 col-sm-6 col-md-2 mb-2 d-flex align-items-center"
                    *ngIf="operation.get('sequenceData')['controls'].length > 1">
                    <i class="fas fa-minus-circle text-danger" style="cursor: pointer"
                      (click)="removeSequence(i, j)"></i>
                  </div>

                </div>
              </div>

            </div>
          </div>

    
          <div class="col-md-12" formArrayName="operationData" *ngIf="!isChecked">
            <div class="row mb-3"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">
                 <div class="form-group col-12 col-md-6 mb-2">
                <label for="processName">Process Name</label>
                  <select
                      id="processName"
                      class="form-control"
                      formControlName="processName"
                    >
                      <option value="" selected disabled>Select Process</option>
                      <option *ngFor="let process of processData" [value]="process.processName">
                        {{ process.processName }}
                      </option>
                    </select>
                 
                 </div>

              <div class="col-12 col-md-6 mb-2">
                <label class="required">Operation Number</label>
                <input type="number" class="form-control" placeholder="Enter Operation Number"
                  formControlName="operationName"
                  [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors"
                  class="text-danger" style="font-size: 11px; margin-top: 3px;">
                  <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                  <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                  <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                  <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Operation Number must be unique.</span>
                </div>
              </div>

        
             <div class="col-12 col-md-6 mb-2">
              <label class="required">Parts/Panel Target</label>
              <div class="input-group">
                <input type="number" class="form-control" placeholder="Enter Target"
                  formControlName="target"
                  [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.target').errors }" />

                <select class="form-control" style="max-width: 80px;"
                  formControlName="targetHours"
                  [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.targetHours').errors }">
                  <option value="">Hrs</option>
                  <option *ngFor="let h of hoursArray" [value]="h">{{ h }}</option>
                </select>
              </div>
              <div *ngIf="submitted && validationform.get('operationData.' + i + '.target').errors"
                class="text-danger" style="font-size: 11px; margin-top: 3px;">
                <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.required">Target is required.</span>
                <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.negativeValue">Cannot be negative.</span>
                <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.decimalNotAllowed">No decimals allowed.</span>
              </div>
              <div *ngIf="submitted && validationform.get('operationData.' + i + '.targetHours').errors"
                class="text-danger" style="font-size: 11px; margin-top: 3px;">
                <span *ngIf="validationform.get('operationData.' + i + '.targetHours').errors?.required">Hour selection is required.</span>
              </div>
            </div>

            <div class="col-12 col-md-6 mb-2">
              <label>Per Part Cycle Time (sec)</label>
              <input type="text" class="form-control" readonly
                [value]="getPerPartCycleTime(i)" placeholder="Auto calculated" />
            </div>
             <span *ngIf="validationform.get('operationData')['controls'].length > 1"
                  class="d-flex align-items-center px-2" style="cursor: pointer;" (click)="removeOperation(i)">
                  <i class="fas fa-minus-circle text-danger"></i>
                </span>
            </div>
          </div>

        </div>
   
        <div class="row">
          <div class="form-group col-md-6">
            <h4 class="card-title">
              Add Operation
              <span style="position: absolute; margin-left: 2%">
                <i class="fas fa-plus-circle" (click)="addOperation()"
                  style="color: rgb(72, 255, 0); cursor: pointer; margin-left: 10px;"
                  title="Add Operation"></i>
              </span>
            </h4>
          </div>
        </div>

        <div class="text-right">
          <button type="submit" class="btn btn-success">Save</button>
          <button type="button" class="btn btn-danger ml-1" (click)="cancel()">Cancel</button>
        </div>

      </form>
    </div>
  </div>
</ng-template>


<ng-template #deletetemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Delete Program</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <p>Are you sure to Delete?</p>
    <button type="button" class="btn btn-danger round waves-effect" (click)="delete(delprogramId)">Delete</button>
    &nbsp;
    <button type="button" class="btn btn-info round waves-effect" (click)="modal('Cross click')">Cancel</button>
  </div>
</ng-template>


<ng-template #Operation role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Operation</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div *ngFor="let op of operationTempData" class="border rounded p-2 mb-4">
      <div class="table-responsive mb-3">
        <table class="table table-sm table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Operation</th>
              <th *ngIf="op.target != null">12 Hour Target</th>
              <th *ngIf="op.runningTime != null">Runtime (sec)</th>
              <th *ngIf="op.loadingTime != null">Loading (sec)</th>
              <th *ngIf="op.unloadingTime != null">Unloading (sec)</th>
              <th *ngIf="op.standardSetupTime != null">Setuptime (sec)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ op.operationName }}</td>
              <td *ngIf="op.target != null">{{ op.target }}</td>
              <td *ngIf="op.runningTime != null">{{ op.runningTime }}</td>
              <td *ngIf="op.loadingTime != null">{{ op.loadingTime }}</td>
              <td *ngIf="op.unloadingTime != null">{{ op.unloadingTime }}</td>
              <td *ngIf="op.standardSetupTime != null">{{ op.standardSetupTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="op.sequenceData && op.sequenceData.length > 0">
        <h6 class="mt-2"><strong>Sequence Data</strong></h6>
        <table class="table table-sm table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Sequence Number</th>
              <th>Running Time (sec)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let seq of op.sequenceData">
              <td>{{ seq.seqNumber }}</td>
              <td>{{ seq.runningTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template> -->

<div class="container-fluid">
  <app-pagetitle title="Job Cards" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-between">
            <a class="btn btn-success mb-2" (click)="openModal(content, '', 'Add')">
              <i class="mdi mdi-plus mr-2"></i> Add Jobs
            </a>
            <div>
              <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
            </div>
          </div>

          <div class="table-responsive mt-3" *ngIf="programData.length != 0">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%">
              <thead class="thead-dark">
                <tr>
                  <th>Part Id</th>
                  <th>Program Name</th>
                  <th>Part Name</th>
                  <th>Operation</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of programData | filter: searchTerm | slice: pageSize | slice: 0: itemsPerPage; let i = index">
                  <td>{{ item.programId }}</td>
                  <td>{{ item.programName }}</td>
                  <td>{{ item.partName }}</td>
                  <td>
                    <i class="mdi mdi-eye" title="View" style="cursor: pointer;"
                      (click)="openModalOperation(Operation, item)"></i>
                  </td>
                  <td>
                    <a (click)="openModal(content, item, 'Edit')" class="mr-3 text-primary" title="Edit" style="cursor: pointer">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a class="text-danger" title="Delete" style="cursor: pointer" (click)="openModalDelete(deletetemp, item)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6" *ngIf="programData?.length > 3">
              <ngb-pagination class="pagination-rounded" [collectionSize]="programData?.length" #numPages
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true"
                [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
              </ngb-pagination>
            </div>
          </div>

          <div class="card" *ngIf="programData.length == 0">
            <span *ngIf="errmsg == ''"><strong>No Job Cards Found. Please Add Job Cards</strong></span>
            <span *ngIf="errmsg != ''"><strong>{{ errmsg }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }} Jobs</h5>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="validationform" autocomplete="off">

 
        <div class="border rounded p-3 mb-3" style="border-color: #b0b8c1 !important;">
          <p class="font-weight-bold mb-3" style="font-size: 13px; color: #495057; letter-spacing: 0.4px;">
            📋 Part Information
          </p>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="programId" class="required">Part Id</label>
              <input type="text" maxlength="32" class="form-control" id="programId"
                placeholder="Enter Part Id" formControlName="programId"
                [ngClass]="{ 'is-invalid': submitted && form.programId.errors }" />
              <div *ngIf="submitted && form.programId.errors" class="invalid-feedback">
                <span *ngIf="form.programId.errors.required">Part Id is mandatory.</span>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="partName" class="required">Part/Model Name</label>
              <input type="text" maxlength="64" class="form-control" id="partName"
                placeholder="Enter Part Name" formControlName="partName"
                [ngClass]="{ 'is-invalid': submitted && form.partName.errors }" />
              <div *ngIf="submitted && form.partName.errors" class="invalid-feedback">
                <span *ngIf="form.partName.errors.required">Part Name is mandatory.</span>
                <span *ngIf="form.partName.errors.pattern">Only letters, numbers, and underscores are allowed.</span>
              </div>
            </div>
         
          </div>

          <div class="row">
               <div class="form-group col-md-6">
              <label for="programName">Program Name</label>
              <input type="text" maxlength="32" class="form-control" id="programName"
                placeholder="Enter Program Name" formControlName="programName"
                [ngClass]="{ 'is-invalid': submitted && form.programName.errors }" />
              <div *ngIf="submitted && form.programName.errors" class="invalid-feedback">
                <span *ngIf="form.programName.errors.required">Program Name is mandatory.</span>
              </div>
            </div>

            <div class="form-group col-md-6">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="partsPerCycleRadio"
                  value="partsPerCycle" formControlName="countingType" />
                <label class="form-check-label" for="partsPerCycleRadio">Parts per Cycle</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="unitsPerPartRadio"
                  value="unitsPerPart" formControlName="countingType" />
                <label class="form-check-label" for="unitsPerPartRadio">Units per Part</label>
              </div>

              <input type="number" class="form-control mt-1" id="partsPerCycle"
                [placeholder]="validationform.get('countingType').value == 'partsPerCycle' ? 'Enter Part Per Cycle' : 'Enter Units Per Part'"
                formControlName="partsPerCycle"
                [ngClass]="{ 'is-invalid': submitted && form.partsPerCycle.errors }" />
              <div *ngIf="submitted && form.partsPerCycle.errors" class="text-danger" style="font-size: 12px; margin-top: 4px;">
                <span *ngIf="form.partsPerCycle.errors?.required">Part per cycle is mandatory.</span>
                <span *ngIf="form.partsPerCycle.errors?.negativeValue">Value cannot be negative.</span>
                <span *ngIf="form.partsPerCycle.errors?.decimalNotAllowed">Decimal values are not allowed.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="border rounded p-3 mb-3" style="border-color: #b0b8c1 !important;">
          <p class="font-weight-bold mb-3" style="font-size: 13px; color: #495057; letter-spacing: 0.4px;">
            ⚙️ Cycle Time & Cost Configuration
          </p>

          <div class="row">
            <div class="form-group col-md-6 d-flex">
              <label for="type">To configure CycleTime</label>&nbsp;
              <input class="form-control" style="width: 15px; margin-top: -10px" type="checkbox"
                [(ngModel)]="isChecked" [ngModelOptions]="{ standalone: true }"
                (change)="onCheckboxChange($event)" id="type" [disabled]="action == 'Edit'" />
            </div>
            <div class="form-group col-md-6 d-flex">
              <label for="operatorCost">To include OperatorCost</label>&nbsp;
              <input class="form-control" style="width: 15px; margin-top: -10px" type="checkbox"
                id="operatorCost" formControlName="operatorCost" />
            </div>
          </div>

          <div class="row" *ngIf="!isChecked">
            <div class="form-group col-md-6" *ngIf="validationform?.get('fixedCost')">
              <label for="fixedCost">Fixed Cost</label>
              <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select FixedCost'"
                [settings]="settings" [data]="fixedCostData" formControlName="fixedCost"
                style="color: #000"></ng-multiselect-dropdown>
            </div>
            <div class="form-group col-md-6" *ngIf="validationform?.get('variableCost')">
              <label for="variableCost">Variable Cost</label>
              <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select VariableCost'"
                [settings]="settings" [data]="variableCostData" formControlName="variableCost"
                style="color: #000"></ng-multiselect-dropdown>
            </div>
          </div>

          <div class="row" *ngIf="isChecked && !issecChecked">
            <div class="form-group col-md-6" *ngIf="validationform?.get('fixedCosts')">
              <label for="fixedCosts">Fixed Cost</label>
              <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select FixedCost'"
                [settings]="settings" [data]="fixedCostData" formControlName="fixedCosts"
                style="color: #000"></ng-multiselect-dropdown>
            </div>
            <div class="form-group col-md-6" *ngIf="validationform?.get('variableCosts')">
              <label for="variableCosts">Variable Cost</label>
              <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select VariableCost'"
                [settings]="settings" [data]="variableCostData" formControlName="variableCosts"
                style="color: #000"></ng-multiselect-dropdown>
            </div>
          </div>

          <div class="row" *ngIf="isChecked && issecChecked">
            <div class="form-group col-md-6" *ngIf="validationform?.get('fixedCostss')">
              <label for="fixedCostss">Fixed Cost</label>
              <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select FixedCost'"
                [settings]="settings" [data]="fixedCostData" formControlName="fixedCostss"
                style="color: #000"></ng-multiselect-dropdown>
            </div>
            <div class="form-group col-md-6" *ngIf="validationform?.get('variableCostss')">
              <label for="variableCostss">Variable Cost</label>
              <ng-multiselect-dropdown class="dim-border" [placeholder]="'Select VariableCost'"
                [settings]="settings" [data]="variableCostData" formControlName="variableCostss"
                style="color: #000"></ng-multiselect-dropdown>
            </div>
          </div>
        </div>


        <div class="border rounded p-3 mb-3" style="border-color: #b0b8c1 !important;">
          <p class="font-weight-bold mb-3" style="font-size: 13px; color: #495057; letter-spacing: 0.4px;">
            🔧 Operations Configuration
          </p>

          <div class="row" *ngIf="isChecked">
            <div class="form-group col-md-6 d-flex">
              <label for="sectype">To configure Sequential CycleTime</label>&nbsp;
              <input class="form-control" style="width: 15px; margin-top: -10px" type="checkbox"
                [(ngModel)]="issecChecked" [ngModelOptions]="{ standalone: true }"
                (change)="onsecCheckboxChange($event)" id="sectype" [disabled]="action == 'Edit'" />
            </div>
          </div>

          <div formArrayName="operationData" *ngIf="isChecked && !issecChecked">
            <div class="border rounded p-3 mb-2" style="border-color: #b0b8c1 !important;"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">
              <div class="row align-items-start">

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label>Process Name</label>
                  <select class="form-control" formControlName="processName">
                    <option value="" selected disabled>Select Process</option>
                    <option *ngFor="let process of processData" [value]="process.processName">{{ process.processName }}</option>
                  </select>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Operation Number</label>
                  <input type="number" class="form-control" placeholder="Number" formControlName="operationName"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Operation Number must be unique.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Running Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="runningTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.runningTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.runningTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Loading Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="loadingTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.loadingTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.loadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Unloading Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="unloadingTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.unloadingTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.unloadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Setup Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="standardSetupTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-md-2 mb-2 d-flex align-items-center"
                  *ngIf="validationform.get('operationData')['controls'].length > 1">
                  <span style="cursor: pointer;" title="Remove" (click)="removeOperation(i)">
                    <i class="fas fa-minus-circle text-danger"></i>
                  </span>
                </div>

              </div>
            </div>
          </div>

          <div formArrayName="operationData" *ngIf="isChecked && issecChecked">
            <div class="border rounded p-3 mb-2" style="border-color: #b0b8c1 !important;"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">

              <div class="row align-items-start">

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label>Process Name</label>
                  <select class="form-control" formControlName="processName">
                    <option value="" selected disabled>Select Process</option>
                    <option *ngFor="let process of processData" [value]="process.processName">{{ process.processName }}</option>
                  </select>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Operation Number</label>
                  <input type="number" class="form-control" placeholder="Operation Number" formControlName="operationName"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Operation Number must be unique.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Loading Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="loadingTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.loadingTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.loadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Unloading Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="unloadingTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.unloadingTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.unloadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Setup Time (sec)</label>
                  <input type="number" class="form-control" placeholder="Sec" formControlName="standardSetupTime"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                </div>

                <div class="form-group col-12 col-sm-6 col-md-4 mb-2">
                  <label class="required">Total Runtime (sec)</label>
                  <input type="number" class="form-control" formControlName="runningTime" placeholder="Total Runtime" readonly />
                </div>

                <div class="col-12 col-sm-6 col-md-2 mb-2 d-flex align-items-center"
                  *ngIf="validationform.get('operationData')['controls'].length > 1">
                  <span style="cursor: pointer;" title="Remove" (click)="removeOperation(i)">
                    <i class="fas fa-minus-circle text-danger"></i>
                  </span>
                </div>

              </div>

              <div formArrayName="sequenceData" class="mt-3">
                <div class="d-flex align-items-center mb-2">
                  <h6 class="mb-0 font-weight-bold">Sequences</h6>
                  <i class="fas fa-plus-circle ml-2" (click)="addSequenceOperation(i)"
                    style="color: rgb(72, 255, 0); cursor: pointer;" title="Add Sequence"></i>
                </div>

                <div class="row mb-2"
                  *ngFor="let seq of operation.get('sequenceData')['controls']; let j = index"
                  [formGroupName]="j">

                  <div class="form-group col-12 col-sm-6 col-md-3 mb-2">
                    <label class="required">Sequence Number</label>
                    <input type="text" class="form-control" formControlName="seqNumber" placeholder="Sequence"
                      [ngClass]="{ 'is-invalid': submitted && operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors }" />
                    <div *ngIf="submitted && operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors?.required">Required.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-3 mb-2">
                    <label class="required">Running Time (sec)</label>
                    <input type="number" class="form-control" formControlName="runningTime" placeholder="Sec"
                      (input)="calculateTotalRuntime(i)"
                      [ngClass]="{ 'is-invalid': submitted && operation.get('sequenceData')['controls'][j].get('runningTime')?.errors }" />
                    <div *ngIf="submitted && operation.get('sequenceData')['controls'][j].get('runningTime')?.errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.required">Required.</span>
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-2 mb-2 d-flex align-items-center"
                    *ngIf="operation.get('sequenceData')['controls'].length > 1">
                    <i class="fas fa-minus-circle text-danger" style="cursor: pointer" (click)="removeSequence(i, j)"></i>
                  </div>

                </div>
              </div>

            </div>
          </div>

          <div formArrayName="operationData" *ngIf="!isChecked">
            <div class="border rounded p-3 mb-2" style="border-color: #b0b8c1 !important;"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">
              <div class="row">

                <div class="form-group col-12 col-md-6 mb-2">
                  <label>Process Name</label>
                  <select class="form-control" formControlName="processName">
                    <option value="" selected disabled>Select Process</option>
                    <option *ngFor="let process of processData" [value]="process.processName">{{ process.processName }}</option>
                  </select>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <label class="required">Operation Number</label>
                  <input type="number" class="form-control" placeholder="Enter Operation Number" formControlName="operationName"
                    [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Operation Number must be unique.</span>
                  </div>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <label class="required">Parts/Panel Target</label>
                  <div class="input-group">
                    <input type="number" class="form-control" placeholder="Enter Target" formControlName="target"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.target').errors }" />
                    <select class="form-control" style="max-width: 80px;" formControlName="targetHours"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.targetHours').errors }">
                      <option value="">Hrs</option>
                      <option *ngFor="let h of hoursArray" [value]="h">{{ h }}</option>
                    </select>
                  </div>
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.target').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.required">Target is required.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.negativeValue">Cannot be negative.</span>
                    <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.decimalNotAllowed">No decimals allowed.</span>
                  </div>
                  <div *ngIf="submitted && validationform.get('operationData.' + i + '.targetHours').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                    <span *ngIf="validationform.get('operationData.' + i + '.targetHours').errors?.required">Hour selection is required.</span>
                  </div>
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <label>Per Part Cycle Time (sec)</label>
                  <input type="text" class="form-control" readonly [value]="getPerPartCycleTime(i)" placeholder="Auto calculated" />
                </div>

                <div class="col-12 d-flex justify-content-end"
                  *ngIf="validationform.get('operationData')['controls'].length > 1">
                  <span style="cursor: pointer;" (click)="removeOperation(i)">
                    <i class="fas fa-minus-circle text-danger"></i>
                  </span>
                </div>

              </div>
            </div>
          </div>

          <div class="mt-2">
            <span style="cursor: pointer; color: #495057; font-size: 13px; font-weight: 600;" (click)="addOperation()">
              <i class="fas fa-plus-circle mr-1" style="color: rgb(72, 255, 0);"></i> Add Operation
            </span>
          </div>

        </div>

        <div class="text-right">
          <button type="submit" class="btn btn-success">Save</button>
          <button type="button" class="btn btn-danger ml-1" (click)="cancel()">Cancel</button>
        </div>

      </form>
    </div>
  </div>
</ng-template>


<ng-template #deletetemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Delete Jobs</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <p>Are you sure to Delete?</p>
    <button type="button" class="btn btn-danger round waves-effect" (click)="delete(delprogramId)">Delete</button>
    &nbsp;
    <button type="button" class="btn btn-info round waves-effect" (click)="modal('Cross click')">Cancel</button>
  </div>
</ng-template>


<ng-template #Operation role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Operation</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div *ngFor="let op of operationTempData" class="border rounded p-2 mb-4">
      <div class="table-responsive mb-3">
        <table class="table table-sm table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Operation</th>
              <th *ngIf="op.target != null">12 Hour Target</th>
              <th *ngIf="op.runningTime != null">Runtime (sec)</th>
              <th *ngIf="op.loadingTime != null">Loading (sec)</th>
              <th *ngIf="op.unloadingTime != null">Unloading (sec)</th>
              <th *ngIf="op.standardSetupTime != null">Setuptime (sec)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ op.operationName }}</td>
              <td *ngIf="op.target != null">{{ op.target }}</td>
              <td *ngIf="op.runningTime != null">{{ op.runningTime }}</td>
              <td *ngIf="op.loadingTime != null">{{ op.loadingTime }}</td>
              <td *ngIf="op.unloadingTime != null">{{ op.unloadingTime }}</td>
              <td *ngIf="op.standardSetupTime != null">{{ op.standardSetupTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="op.sequenceData && op.sequenceData.length > 0">
        <h6 class="mt-2"><strong>Sequence Data</strong></h6>
        <table class="table table-sm table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Sequence Number</th>
              <th>Running Time (sec)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let seq of op.sequenceData">
              <td>{{ seq.seqNumber }}</td>
              <td>{{ seq.runningTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>